export default "__VITE_ASSET__Bdu0fQOJ__"